__turbopack_context__.v({
  "boxWithMargin": "Whrtaa_boxWithMargin",
  "infoBox": "Whrtaa_infoBox",
  "miniSiteInfoBox": "Whrtaa_miniSiteInfoBox",
});
